<template>
  <div>
    <div class="row" style="max-width:1300px">
      <div class="col-12">
        <label class="font28 color_orange font500"> SMS FAST</label>
        <div class="font400">
          บริการส่ง SMS ผ่านเว็บ, ส่ง SMS ปริมาณมาก (Bulk SMS)
          สำหรับนำไปใช้ทำการตลาดผ่าน SMS (SMS Marketing) เช่น
          ประชาสัมพันธ์สินค้าหรือบริการ แจ้งโปรโมชั่น หรือใช้กับระบบสมาชิก เช่น
          แจ้งข่าวสาร แจ้งเตือนต่างๆ หรือสามารถนำไปประยุกต์ใช้ได้ตามความต้องการ
        </div>
        <div class="mt-3"><img src="/images/banner.png" width="100%" /></div>
      </div>
    </div>
    <div
      class="row bd-highlight pt-4 mt-2 mx-0"
      style="max-width:1300px;"
      v-if="promotion.length > 0"
    >
      <div
        class="col-12 col-md-3 px-1 pr-md-1 pb-3"
        v-for="(items, key) in promotion"
        :key="key"
      >
        <div class=" font400 text-center px-2 card">
          <div class="pt-2">{{ items.pro_name }}</div>
          <div class="font24">{{ items.avg_price }}</div>
          <div class="font13">บาท / SMS</div>
          <div>
            <hr class="hr-vertical" />
          </div>
          <div class="text-left font13 pl-2 pt-2">
            <i class="fa fa-check green-text"></i> {{ items.pro_price }} บาท
          </div>
          <div class="text-left font13 pl-2 pt-2">
            <i class="fa fa-check green-text"></i> จำนวนเครดิตที่ได้
            {{ items.pro_credit }}
          </div>
          <div class="text-left font13 pl-2 pt-2">
            <i class="fa fa-check green-text"></i> อายุการใช้งาน
            {{ items.expire_date }} เดือน
          </div>
          <div class="text-left font13 pl-2 pt-2">
            <i class="fa fa-check green-text"></i> มี Report แจ้งสถานะ
          </div>
          <div class="text-left font13 pl-2 pt-2">
            <span v-if="items.amount_sender > 0"
              ><i class="fa fa-check green-text pr-1"></i>
              {{ items.amount_sender }} Sender Name**</span
            >
            <span v-else
              ><i class="fa fa-times red-text pr-1"></i> No Sender Name**</span
            >
          </div>
          <div>
            <button
              @click="Sendpackage(items.id)"
              type="button"
              class="btn btn-search color_white font12 mt-4 mb-3"
            >
              ซื้อแพ็คเกจ
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 font13 text-right font400">
        *โปรเก่าต้องหมดอายุก่อน ถึงจะสามารถอัพเกรดโปรอื่นได้
      </div>
    </div>

    <div class="modal-wrapper" v-if="databank != null">
      <mdb-container>
        <mdb-modal
          :show="showModal"
          @close="showModal = false"
          scrollable
          centered
        >
          <mdb-modal-header>
            <mdb-modal-title>
              <mdb-icon icon="fingerprint" />
              ซื้อแพ็คเกจ {{ databank.promotion_name }}</mdb-modal-title
            >
          </mdb-modal-header>
          <mdb-modal-body>
            <div class="row">
              <div class="col-12 text-center my-4">
                <div class="card-deposit-blog">
                  <p></p>
                  <h2 class="price-wrapper">
                    {{ formatPrice(databank.amount) }}
                  </h2>
                  <p class="date-wrapper">
                    <vue-countdown-timer
                      @end_callback="endCallBack()"
                      :start-time="$moment().format('YYYY-MM-DD')"
                      :end-time="endtime"
                      :interval="1000"
                      :minutes-txt="'นาที'"
                      :seconds-txt="'วินาที'"
                      class="my-2"
                    >
                      <template slot="countdown" slot-scope="scope"
                        ><center>
                          <span class="text-danger">
                            กรุณาโอนเงินภายใน
                            <span> {{ scope.props.minutes }}</span>
                          </span>
                          <span class="text-danger">:</span>
                          <span class="text-danger"
                            >{{ scope.props.seconds }} วินาที</span
                          >
                        </center>
                      </template>
                    </vue-countdown-timer>
                  </p>
                </div>
                <div class="card-deposit-blog">
                  <div
                    class="bank-infor-blog d-flex align-items-center justify-content-center"
                  >
                    <img
                      :src="'/images/BANK/' + databank.bank_code + '.png'"
                      alt=""
                    />
                    <div class="infor-bank-wrap text-left ml-3">
                      <p class="bank-name-wrap">{{ databank.bank_code }}</p>
                      <p>{{databank.full_name}}</p>
                      <p>เลขบัญชี</p>
                    </div>
                  </div>
                  <div
                    class="py-2 d-flex align-items-center justify-content-center"
                  >
                    <h2 class="bank-wrapper mr-2">
                      {{ $banknumber(databank.bank_number) }}
                    </h2>
                    <a>
                      <mdb-badge
                        v-clipboard:copy="databank.bank_number"
                        v-clipboard:success="onCopy"
                        color="primary"
                        ><small class="text-white">คัดลอก</small></mdb-badge
                      ></a
                    >
                  </div>
                  <p>{{ databank.bank_name }}</p>
                  <div class="wrap-blog-notice text-left">
                    <p style="color:red;">เงื่อนไขการโอนเงิน</p>
                    <p>1.ก่อนทำรายการฝาก ลูกค้ากรุณาตรวจสอบหมายเลขบัญชีธนาคารที่หน้าระบบทุกครั้ง</p>
                    <p>2.ลูกค้าต้องโอนเงินผ่านทางแอพพลิเคชั่นของธนาคารเท่านั้น</p>
                    <p>3.ห้ามทำรายการฝากเงินหรือโอนผ่านตู้ ATM จะทำให้ยอดเงินของท่านไม่เข้าสู่ระบบ</p>
                    <p>4.กรุณาโอนจำนวนเงินตามที่แสดงในระบบของเรา </p>
                  </div>
                </div>
              </div>
            </div>
          </mdb-modal-body>
        </mdb-modal>
      </mdb-container>
    </div>
  </div>
</template>

<script>
import { mdbBadge } from "mdbvue";
var axios = require("axios");
import jwt from "jsonwebtoken";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "HomePage",
  components: {
    mdbBadge,
  },
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      tokens: "tokens",
    }),
  },
  data() {
    return {
      showModal: false,
      promotion: [],
      idPackage: null,
      detailPackage: null,
      databank: null,
      endtime: null,
      bankList: require("../../plugins/bank.js").default.data,
    };
  },
  mounted() {
    this.Promotion();
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      callApiMotherFucker: "callApiMotherFucker",
    }),
    Promotion() {
      this.callApiMotherFucker({
        method: "GET",
        path: "/promotion/All",
        data: {},
      }).then((res) => {
        if (res.payload) {
          this.promotion = res.payload;
        }
      });
    },
    Sendpackage(id) {
      this.$swal
        .fire({
          icon: "warning",
          title: "คุณต้องการซื้อแพ็คเกจนี้หรือไม่",
          showCancelButton: true,
          confirmButtonText: "ซื้อแพ็คเกจ",
          confirmButtonColor: "#e0001e",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.Buypackage(id);
            this.showModal = true;
            this.endtime = this.$moment()
              .add(3, "minutes")
              .valueOf();
          } else if (result.isDenied) {
            this.$swal.fire("Changes are not saved", "", "info");
          }
        });
    },
    endCallBack() {
      this.showModal = false;
    },
    Buypackage(id) {
      const payload = {
        promotion_id: id,
      };
      const token = jwt.sign(payload, this.$keypayload);
      var config = {
        method: "POST",
        url: "https://sms-fast.warmlight.online/api/gen_deposit",
        headers: {
          Authorization: "Bearer " + this.tokens,
        },
        data: {
          token: token,
        },
      };
      let context = this;
      axios(config)
        .then(function(response) {
          if (response.data) {
            context.databank = response.data.payload;
			for (const item of  context.bankList) {
				if (item[context.databank.bank_code]){
					context.databank.full_name = item[context.databank.bank_code].name;
				}
			
			}
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    formatPrice(value) {
      return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    onCopy() {
      this.$swal({
        icon: "success",
        html: "คัดลอกสำเร็จ",
        timer: 8000,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },
  },
};
</script>

<style>
.wrap-blog-notice{
  padding: 20px;
}
.wrap-blog-notice p{
  margin: 0 0 5px !important;
}
.border-right {
  border-right: 2px solid #cccccc !important;
}

.border-left {
  border-left: 2px solid #cccccc !important;
}
.card-deposit-blog {
  border: 3px solid #f5904b;
  margin: 15px 0;
  border-radius: 10px;
}
.card-deposit-blog p {
  margin: 0;
}
.card-deposit-blog {
  padding: 15px 0;
}
.price-wrapper {
  font-weight: 500;
}
.bank-wrapper {
  font-weight: 500;
  margin: 0;
}
.bank-infor-blog img {
  width: 60px;
  height: auto;
}
@media only screen and (max-width: 991px) {
  .modal-title {
    font-size: 1.2rem;
  }
  .price-wrapper {
    font-size: 1.2rem;
  }
  .bank-wrapper {
    font-size: 1.2rem;
  }
}
</style>
